var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 208,
    viewBox: "0 0 356 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 188H27.5",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 21H27.5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99059 193.139C4.36748 193.139 3.80735 193.02 3.31019 192.781C2.81635 192.539 2.42193 192.208 2.12695 191.787C1.83197 191.366 1.67454 190.885 1.65465 190.345H3.14613C3.18259 190.783 3.37648 191.142 3.72781 191.424C4.07913 191.706 4.50006 191.847 4.99059 191.847C5.38169 191.847 5.72804 191.757 6.02965 191.578C6.33458 191.396 6.57321 191.146 6.74556 190.827C6.92122 190.509 7.00906 190.146 7.00906 189.739C7.00906 189.324 6.91957 188.955 6.74059 188.63C6.56161 188.305 6.31469 188.05 5.99982 187.864C5.68827 187.679 5.33031 187.584 4.92596 187.581C4.61772 187.581 4.30782 187.634 3.99627 187.74C3.68472 187.846 3.43282 187.985 3.24059 188.158L1.83363 187.949L2.40536 182.818H8.00337V184.136H3.68306L3.35991 186.984H3.41957C3.61843 186.792 3.88192 186.631 4.21005 186.502C4.54149 186.373 4.89613 186.308 5.27397 186.308C5.89376 186.308 6.44561 186.456 6.92951 186.751C7.41673 187.046 7.79954 187.448 8.07795 187.959C8.35967 188.466 8.49888 189.049 8.49556 189.709C8.49888 190.368 8.34973 190.957 8.04812 191.474C7.74982 191.991 7.33552 192.398 6.80522 192.697C6.27823 192.992 5.67335 193.139 4.99059 193.139ZM12.3961 191.608L12.3216 192.15C12.2718 192.548 12.1873 192.962 12.068 193.393C11.952 193.827 11.831 194.23 11.7051 194.601C11.5824 194.972 11.4814 195.267 11.4018 195.486H10.3478C10.3909 195.28 10.4506 195.002 10.5268 194.651C10.603 194.303 10.6776 193.913 10.7505 193.482C10.8234 193.051 10.8781 192.612 10.9146 192.165L10.9643 191.608H12.3961ZM18.074 193.139C17.3614 193.139 16.7317 193.017 16.1848 192.771C15.6413 192.526 15.2154 192.188 14.9071 191.757C14.5989 191.326 14.4464 190.836 14.4498 190.286C14.4464 189.855 14.5343 189.459 14.7132 189.097C14.8955 188.733 15.1425 188.429 15.454 188.188C15.7656 187.942 16.1136 187.786 16.498 187.72V187.661C15.9909 187.538 15.5849 187.266 15.28 186.845C14.9751 186.424 14.8243 185.94 14.8276 185.393C14.8243 184.873 14.9618 184.409 15.2402 184.001C15.522 183.59 15.9081 183.267 16.3986 183.032C16.8891 182.797 17.4476 182.679 18.074 182.679C18.6938 182.679 19.2473 182.798 19.7346 183.037C20.2251 183.272 20.6112 183.595 20.8929 184.006C21.1747 184.414 21.3172 184.876 21.3205 185.393C21.3172 185.94 21.1614 186.424 20.8532 186.845C20.5449 187.266 20.1439 187.538 19.65 187.661V187.72C20.0312 187.786 20.3742 187.942 20.6792 188.188C20.9874 188.429 21.2327 188.733 21.415 189.097C21.6006 189.459 21.695 189.855 21.6983 190.286C21.695 190.836 21.5392 191.326 21.231 191.757C20.9228 192.188 20.4952 192.526 19.9483 192.771C19.4048 193.017 18.78 193.139 18.074 193.139ZM18.074 191.881C18.495 191.881 18.8596 191.812 19.1678 191.673C19.476 191.53 19.7147 191.333 19.8837 191.081C20.0527 190.826 20.1389 190.527 20.1422 190.186C20.1389 189.831 20.0461 189.518 19.8638 189.246C19.6848 188.975 19.4412 188.761 19.133 188.605C18.8248 188.449 18.4718 188.371 18.074 188.371C17.673 188.371 17.3167 188.449 17.0051 188.605C16.6936 188.761 16.4483 188.975 16.2694 189.246C16.0904 189.518 16.0025 189.831 16.0059 190.186C16.0025 190.527 16.0837 190.826 16.2495 191.081C16.4185 191.333 16.6588 191.53 16.9703 191.673C17.2819 191.812 17.6498 191.881 18.074 191.881ZM18.074 187.143C18.4121 187.143 18.7121 187.076 18.9739 186.94C19.2357 186.804 19.4412 186.615 19.5904 186.373C19.7428 186.131 19.8207 185.848 19.824 185.523C19.8207 185.205 19.7445 184.926 19.5953 184.688C19.4495 184.449 19.2457 184.265 18.9838 184.136C18.722 184.003 18.4187 183.937 18.074 183.937C17.7227 183.937 17.4145 184.003 17.1493 184.136C16.8875 184.265 16.6837 184.449 16.5378 184.688C16.392 184.926 16.3207 185.205 16.324 185.523C16.3207 185.848 16.3936 186.131 16.5428 186.373C16.6919 186.615 16.8974 186.804 17.1593 186.94C17.4244 187.076 17.7293 187.143 18.074 187.143Z",
    fill: "#0B1B29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7251 15.8182V26H19.1839V17.3594H19.1243L16.6882 18.9503V17.4787L19.2287 15.8182H20.7251Z",
    fill: "#0B1B29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7482_187336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7482_187336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 10,
    width: 105,
    height: 188,
    rx: 6,
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 39C57.5 34.0294 61.5294 30 66.5 30H153.5C158.471 30 162.5 34.0294 162.5 39V178H57.5V39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 40H71.9026V56H67.5L71.2356 48L67.5 40Z",
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6358 40H121.799V56H71.6358V40Z",
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.532 40H122.333L126.469 48L122.333 56H121.532V40Z",
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.344 40H128.727V56H124.344L128.063 48L124.344 40Z",
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.461 40H134.836V56H128.461V40Z",
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.57 40H135.367L139.484 48L135.367 56H134.57V40Z",
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.359 40H141.742V56H137.359L141.078 48L137.359 40Z",
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.477 40H147.852V56H141.477V40Z",
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.586 40H148.383L152.5 48L148.383 56H147.586V40Z",
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.75,
    y: 60.25,
    width: 84.5,
    height: 15.5,
    rx: 1.75,
    fill: "#F3F8F7",
    stroke: "#1B1C17",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.75,
    y: 80.25,
    width: 84.5,
    height: 15.5,
    rx: 1.75,
    fill: "#F3F8F7",
    stroke: "#1B1C17",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.75,
    y: 100.25,
    width: 84.5,
    height: 15.5,
    rx: 1.75,
    fill: "#F3F8F7",
    stroke: "#1B1C17",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.75,
    y: 120.25,
    width: 84.5,
    height: 15.5,
    rx: 1.75,
    fill: "#F3F8F7",
    stroke: "#1B1C17",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 140,
    width: 85,
    height: 16,
    rx: 2,
    fill: "#ADD53A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 178,
    width: 105,
    height: 20,
    fill: "#204E47"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7482_187336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7482_187336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.5,
    y: 10,
    width: 105,
    height: 188,
    rx: 6,
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5 39C204.5 34.0294 208.529 30 213.5 30H300.5C305.471 30 309.5 34.0294 309.5 39V178H204.5V39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 40,
    width: 85,
    height: 16,
    rx: 2,
    fill: "#DBE9E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 60,
    width: 85,
    height: 16,
    rx: 2,
    fill: "#DBE9E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 80,
    width: 85,
    height: 16,
    rx: 2,
    fill: "#DBE9E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 100,
    width: 85,
    height: 16,
    rx: 2,
    fill: "#DBE9E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 120,
    width: 85,
    height: 16,
    rx: 2,
    fill: "#ADD53A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 140.25,
    width: 84.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#1B1C17",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.5,
    y: 178,
    width: 105,
    height: 20,
    fill: "#204E47"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5 128H299.5",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 84H152.5",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5 68H299.5",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M335.822 133L340.267 124.21V124.136H335.126V122.818H341.858V124.18L337.428 133H335.822ZM344.291 131.608L344.216 132.15C344.166 132.548 344.082 132.962 343.963 133.393C343.847 133.827 343.726 134.23 343.6 134.601C343.477 134.972 343.376 135.267 343.296 135.486H342.242C342.285 135.28 342.345 135.002 342.421 134.651C342.498 134.303 342.572 133.913 342.645 133.482C342.718 133.051 342.773 132.612 342.809 132.165L342.859 131.608H344.291ZM350.133 122.679C350.587 122.682 351.034 122.765 351.475 122.928C351.916 123.09 352.314 123.355 352.668 123.723C353.026 124.091 353.311 124.588 353.523 125.214C353.739 125.838 353.848 126.613 353.851 127.541C353.851 128.433 353.762 129.227 353.583 129.923C353.404 130.615 353.147 131.2 352.812 131.678C352.481 132.155 352.078 132.518 351.604 132.766C351.13 133.015 350.597 133.139 350.003 133.139C349.397 133.139 348.858 133.02 348.388 132.781C347.917 132.543 347.534 132.213 347.239 131.792C346.944 131.368 346.76 130.88 346.687 130.33H348.204C348.303 130.768 348.505 131.122 348.81 131.394C349.118 131.663 349.516 131.797 350.003 131.797C350.749 131.797 351.331 131.472 351.748 130.822C352.166 130.17 352.376 129.258 352.38 128.088H352.3C352.128 128.373 351.912 128.618 351.654 128.824C351.399 129.029 351.112 129.188 350.794 129.301C350.476 129.414 350.136 129.47 349.775 129.47C349.188 129.47 348.654 129.326 348.174 129.038C347.693 128.749 347.31 128.353 347.025 127.849C346.74 127.346 346.598 126.771 346.598 126.124C346.598 125.481 346.744 124.898 347.035 124.374C347.33 123.851 347.741 123.436 348.268 123.131C348.799 122.823 349.42 122.672 350.133 122.679ZM350.138 123.972C349.75 123.972 349.4 124.068 349.089 124.26C348.78 124.449 348.537 124.706 348.358 125.031C348.179 125.352 348.089 125.71 348.089 126.104C348.089 126.499 348.175 126.857 348.348 127.178C348.523 127.496 348.762 127.75 349.064 127.939C349.369 128.125 349.717 128.217 350.108 128.217C350.399 128.217 350.671 128.161 350.923 128.048C351.175 127.936 351.395 127.78 351.584 127.581C351.773 127.379 351.921 127.15 352.027 126.895C352.133 126.64 352.186 126.371 352.186 126.089C352.186 125.715 352.096 125.367 351.917 125.045C351.742 124.724 351.5 124.465 351.192 124.27C350.883 124.071 350.532 123.972 350.138 123.972Z",
    fill: "#0B1B29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.266 87.0114V85.7685L192.665 78.8182H193.645V80.6477H193.023L189.876 85.6293V85.7088H195.907V87.0114H188.266ZM193.093 89V86.6335L193.103 86.0668V78.8182H194.56V89H193.093Z",
    fill: "#0B1B29"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M339.024 73.1392C338.341 73.1392 337.732 73.0215 337.195 72.7862C336.661 72.5509 336.238 72.2244 335.927 71.8068C335.619 71.3859 335.453 70.8987 335.43 70.3452H336.991C337.011 70.6468 337.112 70.9086 337.294 71.1307C337.48 71.3494 337.722 71.5185 338.02 71.6378C338.318 71.7571 338.65 71.8168 339.014 71.8168C339.415 71.8168 339.77 71.7472 340.078 71.608C340.39 71.4687 340.633 71.2749 340.809 71.0263C340.985 70.7744 341.072 70.4844 341.072 70.1562C341.072 69.8149 340.985 69.5149 340.809 69.2564C340.637 68.9946 340.383 68.7891 340.048 68.6399C339.717 68.4908 339.316 68.4162 338.845 68.4162H337.985V67.1634H338.845C339.223 67.1634 339.554 67.0954 339.839 66.9595C340.128 66.8236 340.353 66.6347 340.516 66.3928C340.678 66.1475 340.759 65.8608 340.759 65.5327C340.759 65.2178 340.688 64.9444 340.545 64.7124C340.406 64.477 340.207 64.2931 339.949 64.1605C339.694 64.0279 339.392 63.9616 339.044 63.9616C338.713 63.9616 338.403 64.023 338.114 64.1456C337.829 64.2649 337.597 64.4373 337.418 64.6626C337.239 64.8847 337.143 65.1515 337.13 65.4631H335.643C335.66 64.9129 335.822 64.429 336.131 64.0114C336.442 63.5937 336.853 63.2673 337.364 63.032C337.874 62.7966 338.441 62.679 339.064 62.679C339.717 62.679 340.28 62.8066 340.754 63.0618C341.232 63.3137 341.599 63.6501 341.858 64.071C342.12 64.492 342.249 64.9527 342.246 65.4531C342.249 66.0232 342.09 66.5071 341.768 66.9048C341.45 67.3026 341.026 67.5694 340.496 67.7053V67.7848C341.172 67.8875 341.696 68.156 342.067 68.5902C342.441 69.0244 342.627 69.563 342.624 70.206C342.627 70.7661 342.471 71.2682 342.156 71.7124C341.845 72.1565 341.419 72.5062 340.879 72.7614C340.338 73.0133 339.72 73.1392 339.024 73.1392Z",
    fill: "#0B1B29"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7482_187336",
    x: 47.5,
    y: 0,
    width: 125,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7482_187336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7482_187336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7482_187336",
    x: 194.5,
    y: 0,
    width: 125,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7482_187336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7482_187336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7482_187336"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 10,
    width: 105,
    height: 188,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7482_187336"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.5,
    y: 10,
    width: 105,
    height: 188,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileReference);
export default __webpack_public_path__ + "static/media/mobile-reference.fdbe6eb37e5dd734e836cb598e6ee73d.svg";
export { ForwardRef as ReactComponent };